import { useGetFactorLimitsActivitiesQuery } from "@/app/api";
import { FactorLimit } from "@/app/api/types";
import { UITable } from "@/shared/ui/ui-table";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { numericFormatter } from "react-number-format";

interface Props {
  data: FactorLimit;
}

export const FactorLimitActivities: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const { data: activities, isLoading } = useGetFactorLimitsActivitiesQuery({
    id: data.unique,
  });

  return (
    <UITable
      data={activities?.data || []}
      isLoading={isLoading}
      columns={[
        {
          label: t("date"),
          key: "createdAt",
        },
        {
          label: t("limit"),
          render: (row) =>
            numericFormatter((row.balance || 0).toFixed(2), {
              thousandSeparator: " ",
            }),
        },
        {
          label: t("factor_limit_activity_chanched_on"),
          render: (row) =>
            numericFormatter((row.amount || 0).toFixed(2), {
              thousandSeparator: " ",
            }),
        },
        {
          label: t("base"),
          key: "detail",
        },
      ]}
    />
  );
};
